import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteText from '../../../SatelliteText/SatelliteText';
import satelliteIcon from '../../../satelliteIcon';

const ReduceAbsenteeism2 = props => (
    <ServiceSection noPadBottom noPadTitle singleTitle icon={satelliteIcon} {...props} page="reduceAbsenteeism" section="whatIs">
        <div className='TextGroup Satellite'>
            <div className='container-custom subtitle'>
                <SatelliteText t={props.t} prefix="reduceAbsenteeism:whatIs" first noPadBottom />
            </div>
        </div>
    </ServiceSection>
);

export default ReduceAbsenteeism2;
